import Alert from "@amzn/meridian/alert";
import Toaster from "@amzn/meridian/toaster";
import { observer } from "mobx-react-lite";
import React from "react";

import { commonUnityStore } from "../store/CommonUnityStore";
import { CustomToasterProps } from "../types/Toaster.types";

const CustomToaster = ({
  toasterAlignmentHorizontal,
  toasterAlignmentVertical,
  toasterPosition,
}: CustomToasterProps) => {
  
  const { toasterData, handleOnCloseToaster } = commonUnityStore;
  const { type, size, titleLevel, width, title, text, array } = toasterData;

  return (
    <Toaster
      toasts={array}
      onCloseToast={handleOnCloseToaster}
      alignmentHorizontal={toasterAlignmentHorizontal}
      alignmentVertical={toasterAlignmentVertical}
      position={toasterPosition}
    >
      {({ onClose }) => (
        <Alert
          data-testid="customtoaster-notification-alert"
          toast={true}
          onClose={onClose}
          type={type}
          size={size}
          titleLevel={titleLevel}
          width={width}
          title={title}
        >
          {text}
        </Alert>
      )}
    </Toaster>
  );
};

export default observer(CustomToaster);
